import { useEffect, useRef, useState } from "react";
import { SelectChoice, SetupKind } from "../../../helpers/types";
import { useLazyQuery } from "@apollo/client";
import { GET_SETUPS_MINIMAL } from "../../../graphql/queries";

import { ComboboxItem, OptionsFilter, Select } from "@mantine/core";
import { FieldData } from "../../../hooks/useForm";
const CloseIcon = () => {
   return (
      <svg height='16' width='16' viewBox='0 0 20 20'>
         <path d='M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z'></path>
      </svg>
   );
};

const SetupMultiSelect = ({
   placeHolder,
   setupKind,
   isMulti,
   formData,
   options,
   onChange,
   ...rest
}: {
   name: string;
   label?: string;
   placeHolder?: string;
   setupKind?: SetupKind;
   options?: {
      required?: boolean;
      isRequired?: Function;
   };
   isMulti?: boolean;
   readOnly?: boolean;
   onChange?: Function;
   formData?: Map<string, any>;
}) => {
   console.log({ fieldName: rest.name, formData });
   const [choices, setChoices] = useState<SelectChoice[]>([]);
   const [getSetups] = useLazyQuery(GET_SETUPS_MINIMAL, {
      fetchPolicy: "network-only",
   });

   function getSelectValue() {
      console.log({ formData, name: rest.name })
      let v = formData?.get(rest.name);
      return `${v}`
   }

   const initVal = (): SelectChoice | SelectChoice[] | undefined => {
      const value = formData?.get(rest.name);
      if (!value) return isMulti ? [] : undefined;

      if (Array.isArray(value)) return choices.filter((o) => value.includes(o.value));

      let res = choices.find((o) => o.value === value);
      return res;
   };

   const initValue = initVal();
   const [show, setShow] = useState(false);
   const [isChanged, setIsChanged] = useState(false);
   const [selected, setSelected] = useState<SelectChoice | SelectChoice[] | undefined>();
   const [searchValue, setSearchValue] = useState("");
   const selectElRef = useRef<HTMLDivElement>(null);

   const removeOption = (option: SelectChoice) => {
      if (!Array.isArray(selected)) return [];
      return selected.filter((o) => o.value !== option.value);
   };
   const onTagRemove = (e: any, option: SelectChoice) => {
      e.stopPropagation();
      if (!Array.isArray(selected)) return;
      setSelected(removeOption(option));
   };

   useEffect(() => {
      if (!setupKind) {
         console.error("No setup kind provided");
         return;
      }

      // console.log({ searchValue });
      const currValue = formData?.get(rest.name);
      // const currValue = initVal();
      let selectedIds: number[] = [];
      if (currValue) {
         if (Array.isArray(currValue)) {
            selectedIds = currValue.map((s) => parseInt(s.value || s));
         } else {
            selectedIds = [parseInt(currValue)];
         }
      }
      // console.log({ name: rest.name, choices, currValue, selectedIds });

      console.log({ x: "Fetch setups... ", currValue, name: rest.name });
      getSetups({
         variables: {
            names: [setupKind],
            filter: searchValue,
            selected: selectedIds,
         },
      }).then((res) => {
         let resSetups = res.data.getSetups;
         let kSetups = resSetups;
         console.log({ resSetups })
         let resData = kSetups.records.filter((s: any) => {
            console.log({ status: s.status })
            return ["active"].includes(s.status)
         }).map((s: any) => {
            let name = s.fields.find((f: any) => f.name === "name")?.value;
            let formId = s.id;
            return {
               label: name,
               value: formId,
            };
         });
         console.log({ x: "Fetched setups", currValue, name: rest.name, resData });
         setChoices(() => resData);
      });
   }, [setupKind, searchValue]);

   useEffect(() => {
      // const handler = () => setShow(false);
      // window.addEventListener("click", handler);
      if (selectElRef.current) {
         let el = selectElRef.current;
         let rect = el.getBoundingClientRect();
         el.style.setProperty("--pos-top", `${rect.top}`);
         el.style.setProperty("--pos-left", `${rect.left}`);
         el.style.setProperty("--pos-width", `${rect.width}`);
      }
      // return () => window.removeEventListener("click", handler);
   }, []);
   // useEffect(() => {
   //    setSearchValue("");
   //    if (show && searchRef.current) {
   //       searchRef.current?.focus();
   //    }
   // }, [show]);

   const getValue = () => {
      if (selected === null) return null;
      if (!Array.isArray(selected)) return selected?.value;
      return selected.map((i) => i.value);
   };
   useEffect(() => {
      if (!isChanged) {
         setIsChanged(true);
         return;
      }
      if (!onChange) return;

      onChange({
         name: rest.name,
         value: getValue(),
      });
   }, [selected]);

   useEffect(() => {
      console.log({ fieldName: rest.name, initValue });
      setSelected(initValue);
   }, [initValue]);



   // return (
   //    <div
   //       className={`dropdown-container relative bottom-1 rounded h-full top-0 ${rest.readOnly ? "readonly" : ""}`}
   //       ref={selectElRef}
   //    >
   //       <input
   //          type='text'
   //          name={rest.name}
   //          defaultValue={formData?.get(rest.name)}
   //          required={options?.required}
   //          className='multiselect-value-holder-input'
   //          style={{
   //             visibility: formData?.has(rest.name) ? "hidden" : undefined,
   //          }}
   //       />
   //       <div
   //          className='dropdown-input flex items-center justify-between select-none h-full gap-2'
   //          style={{ minWidth: 0 }}
   //          onClick={handleSelectClick}
   //       >
   //          <div className='dropdown-selected-value flex-1 pl-3 text-sm'>{getDisplay()}</div>
   //          <div className='dropdown-tools'>
   //             <div className='dropdown-tool'>
   //                <Icon />
   //             </div>
   //          </div>
   //       </div>
   //       {show && !rest.readOnly && (
   //          <OutsideAlerter onOutClick={() => setShow(false)}>
   //             <div className='dropdown-menu absolute overflow-auto bg-white w-full border top-10 shadow-lg rounded'>
   //                <div className='search-box' onClick={(ev: any) => ev.stopPropagation()}>
   //                   <input
   //                      onChange={onSearch}
   //                      value={searchValue}
   //                      ref={searchRef}
   //                      className='w-full border-b outline-none px-3 py-1 text-sm'
   //                      placeholder='Filter ...'
   //                   />
   //                </div>
   //                <div className='dropdown-options-wrap flex flex-col'>
   //                   {choices.map((o, idx) => (
   //                      <div
   //                         key={o.value}
   //                         className={`dropdown-item cursor-pointer px-3 py-1 ${isSelected(o) && "selected"}`}
   //                         onClick={() => onItemClick(o)}
   //                      >
   //                         {o.label}
   //                      </div>
   //                   ))}
   //                </div>
   //             </div>
   //          </OutsideAlerter>
   //       )}
   //    </div>
   // );

   const selectOnChange = (data: FieldData) => {
      onChange && onChange(data);
   };

   const optionsFilter: OptionsFilter = ({ options, search }) => {
      console.log({ options, search });
      if (searchValue !== search) {
         setSearchValue(search);
      }
      const splittedSearch = search.toLowerCase().trim().split(" ");
      return (options as ComboboxItem[]).filter((option) => {
         const words = option.label.toLowerCase().trim().split(" ");
         return splittedSearch.every((searchWord) =>
            words.some((word) => word.includes(searchWord)),
         );
      });
   };

   let selectValue = getSelectValue()
   console.log({ choices, selectValue, t: typeof selectValue });
   return <Select
      placeholder={`Select ${rest.label}`}
      value={selectValue}
      label={rest.label}
      size="md"
      radius={"md"}
      required={options?.required || undefined}
      searchable
      data={
         choices?.map((c) => {
            return {
               value: `${c.value}`,
               label: c.label || "",
            };
         }) || []
      }
      onChange={(value, option) => {
         console.log({ value, option });
         selectOnChange({
            name: rest.name,
            value: choices?.find(
               (c) => c.value?.toString() === value,
            )?.value,
         });
      }}
      filter={optionsFilter}
      readOnly={rest?.readOnly}
      // renderOption={
      //    rest.customComponent
      //       ? (item) =>
      //          rest.customComponent && rest.customComponent(item?.option)
      //       : undefined
      // }
      name={rest.name}
      comboboxProps={{
         withinPortal: true,
      }}
   />
};

export default SetupMultiSelect;
